import React, { useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import './HierarchyDetails.css';


type propsType = {
  formData: {
    [key: string]: any;
  };
  formState:any;
  handleFormChange:(value: string | boolean, key: string, id: any, option:any, code?:number)=>void;
  onInputChange?:(value:string, key:string) => any;
};

const HierarchyDetails = ({ formData,formState,handleFormChange,onInputChange }: propsType) => {
  
  return (
    <div className="create_hierarchy_details_page">
      <form className="form_container_hierarchy_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
          onInputChange={onInputChange}
        />
      </form>
    </div>
  );
};
export default HierarchyDetails;
